export default "__VITE_ASSET__By99PpSq__"